import { defineMessages } from 'react-intl';

// TODO: Remove non-final suffixes after content is finalized
export const messages: {
	dismissButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	acceptAllButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allActionsDismissed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noValidSuggestionsProvided: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allActionsAccepted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	updateWorkItems: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contextMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dismissButton: {
		id: 'conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.dismiss-button.non-final',
		defaultMessage: 'Dismiss',
		description: 'Title for the dismiss button to dismiss all suggestions',
	},
	acceptAllButton: {
		id: 'conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.accept-all-button.non-final',
		defaultMessage: 'Accept all',
		description: 'Title for the accept updates button to accept all suggestions',
	},
	allActionsDismissed: {
		id: 'conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.all-actions-dismissed.non-final',
		defaultMessage: "You've dismissed all suggested updates",
		description: 'Message indicating that all actions have been dismissed',
	},
	noValidSuggestionsProvided: {
		id: 'conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.no-valid-suggestions-provided.non-final',
		defaultMessage: 'No suggestions, try prompting again.',
		description:
			'Message when no action cards can be shown because none of the suggested fields are valid or supported',
	},
	allActionsAccepted: {
		id: 'conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.all-actions-accepted.non-final',
		defaultMessage: "You've accepted all suggested updates",
		description: 'Message indicating that all actions have been accepted',
	},
	updateWorkItems: {
		id: 'conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.update-work-items.non-final',
		defaultMessage: 'Update work items',
		description: 'Title for the update work items button',
	},
	contextMessage: {
		id: 'conversation-assistant-message-actions.jira-update-work-item-all-fields-action-renderer.context-message.non-final',
		defaultMessage:
			'Based on your recent activities and ongoing projects, here are some recommended updates based on <card></card>',
		description: 'Context message indicating the source of updates',
	},
});
